import { defaultAnchorSpec, type AnchorSpec } from '@ar-suite/core'
import type { ProceduralNecklaceOptions } from './procedural'

export interface ProceduralNecklaceProduct {
  id: string
  name: string
  procedural: Partial<ProceduralNecklaceOptions>
  anchor: AnchorSpec
}

function spec(patch: Partial<AnchorSpec> = {}): AnchorSpec {
  const s = defaultAnchorSpec('necklace')
  s.unitScale = 1
  return Object.assign(s, patch)
}

export const PROCEDURAL_NECKLACES: ProceduralNecklaceProduct[] = [
  { id: 'neck-pendant-emerald', name: 'Pendant · Emerald on gold', procedural: { style: 'pendant', accent: 0x1f7a4d, drop: 7 }, anchor: spec() },
  { id: 'neck-mangalsutra', name: 'Mangalsutra · Gold', procedural: { style: 'mangalsutra', drop: 9 }, anchor: spec() },
  { id: 'neck-pearls', name: 'Pearl strand', procedural: { style: 'pearls', drop: 5 }, anchor: spec() },
  { id: 'neck-choker', name: 'Choker · Pearl', procedural: { style: 'choker' }, anchor: spec({ offset: [0, 1.5, 0] }) },
]
